<template>
  <div class="d-flex flex-wrap flex-lg-nowrap search-section">
    <Input
        :class="input.class"
        :placeholder="input.placeholder"
        :shouldHaveSearchClear="true"
        v-if="!options && !input.autocomplete"
        v-model="inputState.input"
        @onInputEnterClick="onClickSearch"
    />
    <Select v-if="!options && input.autocomplete" :options="options" :placeholder="input.placeholder" @placeChanged="handlePlaceChanged" />
    <Select v-if="options" :options="options" :placeholder="input.placeholder" />
    <ButtonBlue
        :text="button.text"
        hyperlink
        :href="button.link"
        :class="button.class"
        v-if="button.link"
    />
    <ButtonBlue
        v-else
        :text="button.text"
        :class="button.class"
        @click="onClickSearch"
    />
  </div>
</template>

<script setup>
  import { ref, watch, reactive, onMounted } from 'vue'
  import ButtonBlue from "@/components/common/ButtonBlue";
  import Input from "@/components/common/Input";
  import Select from "@/components/common/Select";

  const props = defineProps({
    input: {
      value: String,
      placeholder: String,
      class: String,
      autocomplete: Boolean
    },
    button: {
      class: String,
      href: String,
      text: String,
    },
    options: Array
  })

  const state = ref(null)

  const inputState = reactive({
    input: ''
  })

  const emit = defineEmits(['placeChanged', 'changeInput', 'search'])

  const onClickSearch = () => {
    emit('placeChanged', state.value)
    emit('search', inputState.input)
  }

  const handlePlaceChanged = (place) => {
    state.value = place
  }

  onMounted(() => {
    if (props.input.value) {
      inputState.input = props.input.value;
    }
  })

  watch(() => inputState.input, () => {
    emit('changeInput', inputState.input)
  })

  watch(() => props.input.value, () => {
    if (props.input.value) {
      inputState.input = props.input.value;
    }
  })

</script>
